import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-two-arrows",
  "use": "icon-two-arrows-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-two-arrows\">\n<g clip-path=\"url(#icon-two-arrows_clip0_6221_5516)\">\n<path d=\"M10.0008 4.85833L12.6424 7.5L13.8174 6.325L10.0008 2.5L6.17578 6.325L7.35911 7.5L10.0008 4.85833ZM10.0008 15.1417L7.35911 12.5L6.18411 13.675L10.0008 17.5L13.8258 13.675L12.6424 12.5L10.0008 15.1417Z\" fill=\"currentColor\" />\n</g>\n<defs>\n<clipPath id=\"icon-two-arrows_clip0_6221_5516\">\n<rect width=\"20\" height=\"20\" fill=\"currentColor\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol